import React from "react";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
    ResponsiveContainer, Legend, Cell, ReferenceLine, LabelList
} from "recharts";

const PositiveAndNegativeBarChart = ({ data, title, predictionBase, predictionResult, featured_names, pre_data }) => {
    const baseValue = Math.round(predictionBase*1000)/1000;
    const predictionValue = Math.round(predictionResult*1000)/1000;

    // 1️⃣ Creamos los datos ordenados por impacto
    const sortedData = data.flat().map((value, index) => ({
        name: `${featured_names[index].replace(/^pre_/, '')} = ${pre_data[index]}`,
        contribution: value,
        originalValue: (Math.round(value*1000)/1000).toString()
    })).sort((a, b) => Math.abs(b.contribution) - Math.abs(a.contribution)).reverse(); // para que el mayor esté arriba

    // 2️⃣ Acumulamos posiciones de inicio (x0)
    let currentX = baseValue;
    const adjustedData = sortedData.map((item) => {
        const bar = {
            ...item,
            base: currentX,
            x0: currentX,
            x1: currentX + item.contribution,
        };
        currentX += item.contribution;
        return bar;
    });

    // 3️⃣ Dominio X del gráfico
    const allX = adjustedData.flatMap(d => [d.x0, d.x1]);
    const minX = Math.min(...allX, baseValue, predictionValue) - 1;
    const maxX = Math.max(...allX, baseValue, predictionValue) + 1;

    return (
        <div style={{
            width: "95%",
            maxWidth: "1200px",
            height: `${Math.max(adjustedData.length * 35, 800)}px`,
            padding: "20px",
            borderRadius: "10px"
        }}>
            <h3 style={{ textAlign: "center" }}>{title}</h3>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    layout="vertical"
                    data={adjustedData}
                    margin={{ top: 20, right: 40, left: 100, bottom: 10 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        type="number"
                        domain={[minX, maxX]}
                        tick={{ fontSize: 14 }}
                        /*tickFormatter={(value) => value.toFixed(3)}*/
                        tickFormatter={(value) => (Math.round(value*1000)/1000).toString()}
                        allowDataOverflow
                    />
                    <YAxis
                        dataKey="name"
                        type="category"
                        width={180}
                        tick={{ fontSize: 14 }}
                        reversed={true} // 🔥 Esto invierte visualmente el eje Y
                    />
                    <Tooltip
                        formatter={(value) => parseFloat((Math.round(value*1000)/1000).toString())}
                        labelFormatter={(label) => `Feature: ${label}`}
                    />
                    <Legend content={() => null} />

                    {/* Líneas de referencia */}
                    <ReferenceLine
                        x={baseValue}
                        stroke="black"
                        strokeDasharray="3 3"
                        //label={{ value: `Base: ${(Math.round(baseValue*1000)/1000).toString()}`, position: "top", fill: "black", fontSize: 14 }}
                        label={{ value: `Base: ${baseValue}`, position: "top", fill: "black", fontSize: 14 }}
                    />
                    <ReferenceLine
                        x={predictionValue}
                        stroke="red"
                        strokeDasharray="3 3"
                        //label={{ value: `Predicción: ${(Math.round(predictionValue*1000)/1000).toString()}`, position: "top", fill: "red", fontSize: 14 }}
                        label={{ value: `Pred.: ${predictionValue}`, position: "top", fill: "red", fontSize: 14 }}
                    />

                    {/* Barra transparente para usar como base acumulada */}
                    <Bar dataKey="x0" fill="transparent" stackId="a" />

                    {/* Barra de contribuciones reales */}
                    <Bar dataKey="contribution" barSize={20} stackId="a">
                        {adjustedData.map((entry, index) => (
                            <Cell
                                key={index}
                                fill={entry.contribution >= 0 ? "#4CAF50" : "#F44336"}
                            />
                        ))}
                        <LabelList dataKey="originalValue" position="insideRight" fill="black" fontSize={12} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default PositiveAndNegativeBarChart;
